import React from 'react';
import PropTypes from 'prop-types';

function IconClose({ size = 24, className, style, onClick }) {
  return (
    <svg className={className} onClick={onClick} width={size} height={size} style={style} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#383838"/>
      <path d="M16.6667 8.27331L15.7267 7.33331L12 11.06L8.27337 7.33331L7.33337 8.27331L11.06 12L7.33337 15.7266L8.27337 16.6666L12 12.94L15.7267 16.6666L16.6667 15.7266L12.94 12L16.6667 8.27331Z" fill="#A0A0A0"/>
    </svg>
  )
}

IconClose.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func.isRequired,
}

export default IconClose;
